import { render, staticRenderFns } from "./ui-background-file-dropdown.vue?vue&type=template&id=04a82568"
import script from "./ui-background-file-dropdown.vue?vue&type=script&lang=ts"
export * from "./ui-background-file-dropdown.vue?vue&type=script&lang=ts"
import style0 from "./ui-background-file-dropdown.vue?vue&type=style&index=0&id=04a82568&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports